export const FeedbackConfigEnum = {
    Accepted: 1,
    CheckedCorrect: 2,
}